import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="pt-16 min-h-screen flex items-center justify-center px-4 grain relative" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-sm w-full border border-white/10 bg-coal p-8"
      >
        <div className="flex items-center gap-3 mb-8">
          <span className="bg-blood/15 border border-blood/40 p-2.5 text-blood"><Lock size={16} /></span>
          <div>
            <h1 className="font-syne font-extrabold uppercase tracking-tight text-lg leading-none">Espace Admin</h1>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash mt-1">TWELVE 12-SHOP — Accès restreint</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash block mb-2">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-sm focus:outline-none focus:border-blood"
              placeholder="admin@kxa.fr"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash block mb-2">Mot de passe</label>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-sm focus:outline-none focus:border-blood"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="font-mono text-xs text-blood border border-blood/40 bg-blood/10 px-3 py-2">{error}</p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-blood text-white font-mono text-xs uppercase tracking-[0.2em] py-3.5 hover:bg-white hover:text-ink transition-colors disabled:opacity-50"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
